// Benepack OMS · 外键名称展示组件 (fk-name-resolution 切片)
// <RefName kind id mode="short|full"/> → 渲染可读名称·原 #id 作 tooltip 可追溯。
//   - mode="short" (默认): 列表/行内短显示 (customer/supplier 简称‖全称·其余主名)。
//   - mode="full": 详情全显示 (customer/supplier 全称（简称）)。
//   - loading / 缺失 / 解析失败 → 回退灰显 #id·**绝不白屏/报错** (优雅降级硬性要求)。
//   - id 为 0/空 (NULL FK) → 显示占位 emptyText (默认 —)。
import { Tooltip, Typography } from 'antd';
import { useRefNames, refShortText, refFullText, type RefKind } from '@/lib/ref-names';

const { Text } = Typography;

interface RefNameProps {
  kind: RefKind;
  id: number | null | undefined;
  mode?: 'short' | 'full';
  /** NULL/0 FK 时显示的占位 (默认 —)。 */
  emptyText?: string;
}

export default function RefName({ kind, id, mode = 'short', emptyText = '—' }: RefNameProps) {
  const { map } = useRefNames(kind);
  const numId = typeof id === 'number' ? id : Number(id ?? 0);

  if (!numId || numId <= 0) return <>{emptyText}</>;

  const fallback = `#${numId}`;
  const rec = map.get(numId);

  // loading 或 缺记录 (含解析失败缓存空 Map) → 回退灰显 #id·保持可读·不报错。
  if (!rec) {
    return <Text type="secondary">{fallback}</Text>;
  }

  const text = mode === 'full' ? refFullText(kind, rec) : refShortText(kind, rec);
  // 已解析: 显示名称·原 #id 作 tooltip 保留可追溯。
  return (
    <Tooltip title={fallback}>
      <span>{text}</span>
    </Tooltip>
  );
}
